/**
 * @file useContent.js
 * @description 오버라이드와 코드 기본값을 해석해 최종 문구를 반환합니다.
 * @used-in content/Text.jsx
 */

import { useContext } from 'react';
import { ContentContext } from './ContentContext';
import { readInjectedValues } from './contentSource';
import { getDefaultItems, getDefaultText } from './registry';

// [기능] Provider 또는 현재 주입값에서 값 맵을 얻습니다.
// [기술] 두 훅이 같은 해석 순서를 쓰도록 한 곳에 모읍니다.
function useContentValues() {
  const ctx = useContext(ContentContext);
  return ctx ? ctx.values : readInjectedValues();
}

// [기능] Provider 또는 현재 주입값에서 키를 조회하고 없으면 코드 기본값을 반환합니다.
export function useContent(key) {
  const values = useContentValues();
  // [비즈니스] 빈 문자열도 의도적으로 지운 문구이므로 유효한 오버라이드입니다.
  // [기술] own 프로퍼티만 허용해 상속 멤버가 문구로 노출되지 않도록 합니다.
  if (Object.prototype.hasOwnProperty.call(values, key) && typeof values[key] === 'string') {
    return values[key];
  }
  return getDefaultText(key);
}

// [기능] 리스트의 오버라이드를 반환하고 누락되거나 형식이 어긋나면 코드 기본값을 씁니다.
export function useContentList(key) {
  const values = useContentValues();
  // [비즈니스] 빈 배열도 문단을 전부 지운 의도된 상태이므로 기본값으로 되돌리지 않습니다.
  // [기술] 문자열이 아닌 항목이 섞이면 예상 못 한 노드를 막기 위해 목록 전체를 버립니다.
  if (Object.prototype.hasOwnProperty.call(values, key)) {
    const value = values[key];
    if (Array.isArray(value) && value.every((item) => typeof item === 'string')) return value;
  }
  return getDefaultItems(key);
}
